module.exports = __webpack_public_path__ + "media/images/select/select-light-d00b7d99a21295c33d29073c8e96e998.svg";